import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { spinnerSlice } from "../app/actions/spinner/spinnerSlice";
import { reducer as oidcReducer } from "redux-oidc";
import { errorsSlice } from "./errors/errorsSlice";
import loadReducer from "../app/shared_lib/custom/loader/redux/loadSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  spinner: spinnerSlice.reducer,
  errors: errorsSlice.reducer,
  oidc: oidcReducer,
  load: loadReducer,
});
